import { formatToman, persian } from '@roza/shared'

/**
 * Formatting for the panel: Persian digits everywhere, Jalali dates, Toman money.
 *
 * Operators read these numbers all day. A Gregorian date or a Latin numeral in a Persian panel is
 * a small friction that compounds into misreadings, so the conversion happens once here rather
 * than being remembered at each call site.
 */
export const fa = (value: number | string | null | undefined): string =>
  value === null || value === undefined ? '—' : persian.toPersianDigits(String(value))

export const money = (toman: number | null | undefined): string =>
  toman === null || toman === undefined ? '—' : formatToman(toman)

/** «۱۸ مرداد ۱۴۰۵» — the calendar an Iranian operator actually works in. */
export function jalali(value: string | null | undefined, withTime = false): string {
  if (!value) return '—'

  const date = new Date(value)

  if (Number.isNaN(date.getTime())) return '—'

  return new Intl.DateTimeFormat('fa-IR', {
    calendar: 'persian',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
  }).format(date)
}

/** The colour an order status carries through the panel, so one glance sorts a list. */
export function statusSeverity(status: string): 'success' | 'info' | 'warn' | 'danger' | 'secondary' {
  if (['delivered', 'completed', 'paid'].includes(status)) return 'success'
  if (['processing', 'packed', 'shipped'].includes(status)) return 'info'
  if (['pending_payment', 'return_requested'].includes(status)) return 'warn'
  if (['payment_failed', 'cancelled', 'returned', 'refunded'].includes(status)) return 'danger'

  return 'secondary'
}
